import { createClient } from '@supabase/supabase-js'

// Supabase 配置 - 演示配置，请替换为你的实际值
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'demo-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// 数据库表结构类型定义
export interface DrawingRoom {
  id: string
  name: string
  data: any
  updated_at: string
  created_at: string
}

export interface DrawingEvent {
  id: string
  room_id: string
  event_type: string
  event_data: any
  user_id?: string
  created_at: string
} 